import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme/theme';

// Components
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import ServiceDescription from './components/ServiceDescription';
import TestimonialsSection from './components/TestimonialsSection';
import CtaSection from './components/CtaSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <HeroSection />
      <ProblemSection />
      <SolutionSection />
      <ServiceDescription />
      <TestimonialsSection />
      <CtaSection />
      <FaqSection />
      <Footer />
    </ThemeProvider>
  );
}

export default App; 